import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import Button from 'components/button';
import Loader from 'components/loader';
import Price from 'components/price';

export default class TableAlternate extends Component {

  /* Render */

  render() {
    return (
      <table className="table-alternate">
        {this.renderHeader()}
        {this.renderBody()}
        {this.renderFooter()}
      </table>
    );
  }

  renderHeader() {
    const { columns } = this.props;

    if (!columns || !columns.length) return null;

    const headers = columns.map((column) => {
      const modifier = column.modifier ? `table-alternate-header__cell--${column.modifier}` : '';

      return (
        <th
          className={`table-alternate-header__cell ${modifier}`}
          key={`table-alternate-head-${column.accessor}`}
        >
          {!column.hidden ? column.header : ''}
        </th>
      );
    });

    return (
      <thead className="table-alternate-header">
        <tr className="table-alternate-header__row">{headers}</tr>
      </thead>
    );
  }

  renderBody() {
    const { columns, rows } = this.props;

    if (!rows || !rows.length) {
      const columnSize = columns ? columns.length : 1;

      // Render 1 empty row

      return (
        <tbody className="table-alternate-body">
          <tr className="table-alternate-body__row">
            <td className="table-alternate-body__cell" colSpan={columnSize}>
              <div className="table-alternate-body__content">
                <FormattedMessage id="components.table.noTableData" />
              </div>
            </td>
          </tr>
        </tbody>
      );
    }

    const remappedRows = rows.map((row) => {
      const keyRow = row.id;
      let cells = [];

      if (columns && columns.length) {
        cells = columns.map((column) => {
          const keyCell = `${keyRow}-${column.accessor}`;

          let tableCell = null;

          if (column.cell && typeof column.cell === 'function') {
            tableCell = column.cell(row);
          } else {
            tableCell = (<div className="table-alternate-body__content">{row[column.accessor]}</div>);
          }

          return (
            <td key={keyCell} className="table-alternate-body__cell">
              {tableCell}
            </td>
          );
        });
      } else {
        Object.keys(row).forEach((key) => {
          const keyCell = `${keyRow}-${row[key]}`;

          cells.push((
            <td key={keyCell} className="table-alternate-body__cell">
              <div className="table-alternate-body__cell__content">{row[key]}</div>
            </td>
          ));
        });
      }

      return (
        <tr key={keyRow} className="table-alternate-body__row">
          {cells}
        </tr>
      );
    });

    return (
      <tbody className="table-alternate-body">
        {remappedRows}
      </tbody>
    );
  }

  renderFooter() {
    const { addRow, loading, columns, includesVat, subtotal, showPrices } = this.props;
    const columnSize = columns ? columns.length : 1;

    if (!addRow && !subtotal) return null;

    let addButton = null;
    let subtotalNode = null;

    if (addRow) {
      addButton = (
        <Button
          className="button"
          onClick={addRow}
        >
          <span className="icon icon-plus icon--position-left icon--circle icon--xs" />
          <FormattedMessage id="components.table.add" />
        </Button>
      );
    }

    let includesVatNode = null;

    if (includesVat) {
      includesVatNode = <span> (<FormattedMessage id="general.vat.included" />)</span>;
    }

    if (subtotal && showPrices) {
      subtotalNode = (
        <div className="align__cell align__cell--shrink">
          <div className="align align--fluid align--gutter-md">
            <div className="align__cell">
              <FormattedMessage id="components.table.subtotal" />
              {includesVatNode}
            </div>
            <div className="align__cell">
              <Price value={subtotal} />
            </div>
          </div>
        </div>
      );
    }

    return (
      <tfoot className="table-alternate-footer">
        <tr className="table-alternate-footer__row">
          <td className="table-alternate-footer__cell" colSpan={columnSize}>
            <div className="align align--fluid align--gutter-xs">
              <div className="align__cell align__cell--grow">
                {addButton}
              </div>
              <div className="align__cell align__cell--shrink">
                <Loader size="sm" visible={loading} />
              </div>
              {subtotalNode}
            </div>
          </td>
        </tr>
      </tfoot>
    );
  }
}

TableAlternate.defaultProps = {
  loading: false,
  subtotal: 0,
};

TableAlternate.propTypes = {
  addRow: PropTypes.func,
  loading: PropTypes.bool,
  columns: PropTypes.array,
  includesVat: PropTypes.bool,
  rows: PropTypes.array,
  showPrices: PropTypes.bool,
  subtotal: PropTypes.number,
};



// WEBPACK FOOTER //
// ./js/components/table-alternate/index.jsx